import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'wink-customer-orientation',
  shadow: true,
})
export class CustomerOrientation {
  @Element() host!: HTMLWinkCustomerOrientationElement;

  @Prop() singleElement = false;

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
